@if (form) {
    <form [formGroup]="form" fxLayout="column" fxLayoutAlign="center center" class="pr-56 pl-56 pb-48 pt-48 w-100">
        <div class="h3-semi-bold c-primary-gray-900 text-center"> {{ title | translate }}</div>
        <div class="mt-16 t2 c-primary-gray-900 pre-wrap text-center" fxFlexAlign="start">
            {{ subtitle | translate:{id: dialogData.refund.id} }}
        </div>
        <af-dictionary-selector [dictionaryName]="ReferenceBookType.REJECT_TYPE"
                                class="min-max-w-400 mt-24"
                                label="i18n_af_labelRejectReason"
                                placeholder="i18n_af_placeholderSelectRejectReason"
                                [filterDictionaryBy]="filterBy"
                                [control]="form.controls.reason"/>
        <div class="t5 c-primary-gray-600 mt-24" fxFlexAlign="start">{{ 'i18n_af_labelComment' | translate }}</div>
        <mat-form-field fxFlex class="w-100 mt-4">
            <textarea matInput
                      maxlength="{{maxCommentLength}}"
                      class="resize-none pt-12 pb-12"
                      formControlName="comment"></textarea>
            <mat-hint align="end" class="t2 c-primary-gray-600">{{ form.controls.comment.value.length }} / {{ maxCommentLength }}</mat-hint>
        </mat-form-field>
        <ui-kit-button
            class="mt-12"
            color="accent"
            [disabled]="form.invalid"
            (clickListener)="dialogRef.close(form.getRawValue())"
            [label]="rejectButtonLabel | translate"/>
        <ui-kit-button
            class="mt-16"
            type="text"
            (clickListener)="dialogRef.close()"
            [label]="'i18n_af_buttonCancel' | translate"/>
    </form>
}
